import { __, compose, or, path } from 'ramda'
import { capitalizeIfLower, fromNow } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { useUserState } from './_load/UserLoader'
import FieldValuesPresenter from '../../../containers/fieldValues/FieldValuesPresenter'
import LabelValue from '../../../packages/kiti/components/presentation/LabelValue'
import UserPresenter from '../../../containers/users/UserPresenter'
import { useIsOwner, useLoggedUser, useSessionPermission } from '@btime/react-session'

const UserDetails = () => {
  const { t } = useTranslation(['common', 'contracts', 'editUser'])
  const user = useUserState()?.user
  const loggedUser = useLoggedUser()
  const isOwner = useIsOwner()
  const canSeeConfidentialFields = useSessionPermission('seeConfidentialFields')
  const canSeeSignature = user?.id === loggedUser?.id || isOwner
  const fieldValuesToShow = canSeeSignature
    ? user?.contract?.fieldValues
    : (user?.contract?.fieldValues || []).filter(fv => path(['field', 'type'], fv) !== 'signature')

  let { appVersion, os, lastSeen } = user.mobileDetails || {}

  const groupName =
    compose(capitalizeIfLower, path(['contract', 'group', 'name']))(user) ||
    user?.contract?.groups?.map(group => group.name).join(', ')

  lastSeen = compose(or(__, null), fromNow)(lastSeen)

  return (
    <Grid justify="flex-start" align="flex-start" paddingGutter={0.5} wrap>
      <Col width="50%">
        <LabelValue label={t('contracts:email')} value={user.email} />
      </Col>

      <Col width="50%">
        <LabelValue label={t('contracts:profile')} value={user.contract?.profile?.label} />
      </Col>

      {!!user.parent && (
        <Col width="50%">
          <LabelValue label={t('contracts:linkedUser')}>
            <UserPresenter user={user.parent} />
          </LabelValue>
        </Col>
      )}

      {!!groupName && (
        <Col width="50%">
          <LabelValue
            label={groupName?.includes(',') ? t('contracts:groups') : t('contracts:group')}
            value={groupName}
          />
        </Col>
      )}

      {!!lastSeen && (
        <Col width="50%">
          <LabelValue label={t('contracts:lastSeen')} value={lastSeen} />
        </Col>
      )}

      {!!appVersion && !!os && (
        <Col width="50%">
          <LabelValue label={t('contracts:appVersion')} value={`${appVersion} (${os})`} />
        </Col>
      )}

      {!!user?.isFakeEmail && (
        <Col width="50%">
          <LabelValue
            label={t('editUser:fakeEmail')}
            value={user.isFakeEmail === true ? t('common:yes') : t('common:no')}
          />
        </Col>
      )}

      <Col width="100%">
        <FieldValuesPresenter fieldValues={fieldValuesToShow} hideConfidential={!canSeeConfidentialFields} />
      </Col>
    </Grid>
  )
}

export default UserDetails
